import type { FederatedProviderSlug } from '@instanexus/contracts';
import type { ApiClient } from '@instanexus/sdk';

import { saveFederatedReturn, type FederatedReturn } from '@/lib/federated-return';

export const FEDERATED_RESTART_CODE = 'FEDERATED_SIGN_IN_RESTART';

/**
 * After FEDERATED_SIGN_IN_RESTART (ADR 0039 decision 10): saves the next return marked `restarted`
 * and leaves for the provider again. Resolves false — starting nothing — when there is nothing to
 * restart from or this round trip was already a restart. `/start` rejections propagate.
 */
export async function restartFederatedRoundTrip(
  api: Pick<ApiClient, 'federation'>,
  provider: FederatedProviderSlug,
  previous: FederatedReturn | null,
  redirectTo: (url: string) => void,
  storage?: Storage,
): Promise<boolean> {
  if (previous === null || previous.restarted === true) return false;
  const hint = previous.loginHint === undefined ? {} : { loginHint: previous.loginHint };

  if (previous.kind === 'signup') {
    saveFederatedReturn({ kind: 'signup', ...hint, restarted: true }, storage);
  } else {
    const search = previous.kind === 'sign_in' ? previous.search : `client=${previous.client}`;
    saveFederatedReturn({ kind: 'sign_in', search, ...hint, restarted: true }, storage);
  }
  const { authorizeUrl } = await api.federation.start(
    provider,
    previous.kind === 'signup' ? { purpose: 'signup', ...hint } : hint,
  );
  redirectTo(authorizeUrl);
  return true;
}
